var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import TemplateSummaryPopover from "./TemplateSummaryPopover.vue";
import SelectTemplate from "@/components/ConfigTemplates/SelectTemplate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectTemplate',
    props: {
        templates: null
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        const selectText = "Select file source template to create new file sources with. These templates are configured by your Galaxy administrator.";
        function handleSubmit(templateId) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onSubmit", templateId);
            });
        }
        return { __sfc: true, selectText, emit, handleSubmit, TemplateSummaryPopover, SelectTemplate };
    }
});
